import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";
//* fuck
// import Hambarger from "jsdc-dui/dist/components/Icons/Hamburger"

//TODO: EVENT_ID
const EVENT_ID = "n0024";

//TODO: aboutWalkContent
const aboutWalkContent = `《島都之河：匯流與共生，淡水河與臺北的百年互動》一書，描繪了淡水河如何成為臺北的生命之河。自清代的灌溉、航運與開埠通商，到日治時期的防洪構想，再到戰後一連串的治理工程，這條大河始終是城市社會、經濟與文化發展的舞台與見證。

本路線主以「淡水河水上走讀」的體驗，行程循著臺北城市的歷史紋理一路走到大稻埕碼頭，隨後乘船啟程，逆流而上。航行將依序經過台北大橋、社子島、重陽大橋、二重疏洪道直至關渡大橋，並遠眺大屯山與觀音山，沿途不僅能見證都市治理與河川整治的成果，也能感受自然環境與人文景觀交織的獨特風貌。

透過數位教材的輔助與現地踏查的實際體驗，本次小旅行將引領參與者在知識與感官的交錯中，重新構築淡水河的歷史記憶。這不僅是一場學習之旅，更是一趟親近水域、認識城市、感受文化的時光航行。
`;

const credit = `
<div>
    本圖臺是由國立彰化師範大學、經濟部水利署水利規劃分署及智紳數位文化事業有限公司共同協力建置：
    <br>
    <br>1. 圖臺內容：國立彰化師範大學、經濟部水利署水利規劃分署提供
    <br>
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>本圖臺內容其內容著作財產權由國立彰化師範大學與經濟部水利署水利規劃分署所有，若有其他利用或授權需求，請洽下列單位。
    <br>國立彰化師範大學歷史學研究所
    <br>聯絡方式：(04)723-2105 #1933
</div>	
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "新北市", town: "八里區" },
      { county: "新北市", town: "五股區" },
      { county: "臺北市", town: "北投區" },
      { county: "臺北市", town: "大同區" },
      { county: "臺北市", town: "萬華區" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#5044e3", //TODO: theme
    "--dui-accent": "#8f10de", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#5044e3", //TODO: theme
    "--dui-bg-secondary": "#C9B189", // Dialog background
    "--dui-bg-accent": "#4977b4", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線、路線顏色選單都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp language="zh-TW" />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(25.2179192, 121.2860327),
        latLng(25.0158071, 121.6483837)
      ),
      maxZoom: 20,
    })
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider
          {...duiConfigProps}
          pathColorConfig={{ enabled: true }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
